<template>
  <!-- Animated Background -->
  <div class="lm-animated-bg" style="background-image: url(img/main_bg.png)"></div>
  <!-- /Animated Background -->

  <Preloader />

  <div class="page">
    <div class="page-content">
      <header
        id="site_header"
        :class="{ 'header animated': true, 'mobile-menu-hide': !mobileSidebar.enabled }"
        style="z-index: 299"
      >
        <div class="header-content">
          <div class="header-photo">
            <img
              src="/img/my-avatar.webp"
              alt="Alex Smith"
              style="width: 182px; height: 182px; object-fit: cover"
            />
          </div>
          <div class="header-titles">
            <h2>{{ data.name }}</h2>
            <h4 style="font-size: 14px">{{ data.home }}</h4>
          </div>
        </div>

        <Sidebar />

        <div class="social-links">
          <ul>
            <li v-for="(item, i) in data.socialLinks" :key="i">
              <a :href="item.route" target="_blank">
                <i :class="item.icon"></i>
              </a>
            </li>
          </ul>
        </div>

        <div class="header-buttons">
          <a
            href="https://drive.google.com/file/d/1qG9LUwv60U9KTe7HOc9QpMG6sLm3Hqqw/view?usp=sharing"
            target="_blank"
            class="btn btn-primary"
            >Download CV</a
          >
        </div>

        <div class="copyrights">© 2020 All rights reserved.</div>
      </header>

      <!-- Mobile Navigation -->
      <div
        :class="{ 'menu-toggle': true, open: mobileSidebar.enabled }"
        @click="methods.onToggleMobileSidebar"
        style="z-index: 300"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <!-- End Mobile Navigation -->

      <!-- Arrows Nav -->
      <div class="lmpixels-arrows-nav">
        <div class="lmpixels-arrow-right" style="cursor: pointer" @click="() => router.go(+1)">
          <i class="lnr lnr-chevron-right"></i>
        </div>
        <div class="lmpixels-arrow-left" style="cursor: pointer" @click="() => router.go(-1)">
          <i class="lnr lnr-chevron-left"></i>
        </div>
      </div>
      <!-- End Arrows Nav -->

      <div class="content-area">
        <router-view v-slot="{ Component }">
          <transition
            name="router-anim"
            :enter-active-class="PageAnimate.enter"
            :leave-active-class="PageAnimate.leave"
          >
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>
  </div>

  <div
    id="page-ajax-loaded"
    :class="{
      'page-ajax-loaded': true,
      'animated animated-section-moveFromLeft': true,
      'animated-section-moveToRight': !pageAjaxLoaded.enabled,
      closed: !pageAjaxLoaded.enabled
    }"
  >
    <PageAjax v-if="!pageAjaxLoaded.destroy" />
  </div>
</template>
<script>
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import { onMounted, provide, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import AnimateList from './animateList'
import { PageAjax, Preloader, Sidebar } from './components'
import DATA from './data'

export default {
  components: {
    PageAjax,
    Sidebar,
    Preloader
  },
  setup() {
    const router = useRouter()
    const clientWidth = ref(0)
    const pageAjaxLoaded = reactive({
      enabled: false,
      ready: false,
      destroy: true,
      count: 0
    })
    const pageAjaxCounter = ref(0)
    const mobileSidebar = reactive({
      enabled: false
    })
    provide('pageAjaxCounter', pageAjaxCounter)
    provide('pageAjaxLoaded', pageAjaxLoaded)

    const scrollY = ref(0)
    const path = ref('')
    const scrollbar = reactive({
      enabled: false,
      init: false
    })
    const data = reactive(DATA)
    provide('data', data)
    provide('scrollbar', scrollbar)
    provide('clientWidth', clientWidth)
    provide('scrollY', scrollY)
    provide('path', path)

    watch(path, () => {
      methods.getAnimations()
    })

    let container
    let ps
    watch(scrollbar, (on) => {
      if (on.enabled) {
        setTimeout(() => {
          if (on.enabled !== false) {
            if (!container) {
              container = document.querySelector('.animated-section')
            }
            ps = new PerfectScrollbar(container)
          }
        }, 1000)
      } else {
        if (container) {
          container = null
          ps.destroy()
          ps = null
          scrollbar.init = false
        }
      }
    })

    watch(clientWidth, (width) => {
      if (scrollbar.enabled) {
        if (width > 1024) {
          if (!scrollbar.init) {
            scrollbar.init = true
            setTimeout(() => {
              ps = new PerfectScrollbar(container)
            }, 100)
          }
        } else {
          if (scrollbar.init) {
            scrollbar.init = false
            ps.destroy()
            ps = null
          }
        }
      }
    })

    const PageAnimate = reactive({
      enter: '',
      leave: ''
    })

    const methods = {
      getRandomArbitrary: (min, max) => {
        min = Math.ceil(min)
        max = Math.floor(max)
        return Math.floor(Math.random() * (max - min + 1)) + min
      },
      getAnimations: () => {
        const anim = AnimateList[methods.getRandomArbitrary(1, AnimateList.length) - 1]
        PageAnimate.leave = anim.outClass
        PageAnimate.enter = anim.inClass
      },
      myEventHandler() {
        clientWidth.value = document.documentElement.clientWidth
      },
      handleScroll() {
        scrollY.value = window.scrollY
      },
      onToggleMobileSidebar: () => {
        mobileSidebar.enabled = !mobileSidebar.enabled
      }
    }

    onMounted(() => {
      window.addEventListener('resize', methods.myEventHandler)
      window.addEventListener('scroll', methods.handleScroll)
      clientWidth.value = document.documentElement.clientWidth
      scrollY.value = window.scrollY

      const movementStrength = 23
      const height = movementStrength / $(document).height()
      const width = movementStrength / $(document).width()
      $('body').on('mousemove', function (e) {
        let pageX = e.pageX - $(document).width() / 2,
          pageY = e.pageY - $(document).height() / 2,
          newvalueX = width * pageX * -1,
          newvalueY = height * pageY * -1,
          elements = $('.lm-animated-bg')
        elements.addClass('transition')
        elements.css({
          'background-position':
            'calc( 50% + ' + newvalueX + 'px ) calc( 50% + ' + newvalueY + 'px )'
        })
        setTimeout(function () {
          elements.removeClass('transition')
        }, 300)
      })
    })
    return {
      mobileSidebar,
      pageAjaxLoaded,
      PageAnimate,
      data,
      methods,
      router
    }
  }
}
</script>
<style>
.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
